import React, { useState, useEffect } from 'react';
import { api } from '../lib/api';
import { toast } from 'sonner';
import { Play, Square, Loader2 } from 'lucide-react';

const hhmmss = (secs) => {
  const s = Math.max(0, secs);
  const h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(sec).padStart(2, '0')}`;
};

// Clock-in / clock-out control shown under the logo for users with a weekly hour target.
export function ClockInButton({ status, onChange }) {
  const [busy, setBusy] = useState(false);
  const [, setTick] = useState(0);
  const open = status?.open_entry;

  useEffect(() => {
    if (!open) return undefined;
    const t = setInterval(() => setTick(x => x + 1), 1000);
    return () => clearInterval(t);
  }, [open]);

  if (!status?.enabled) return null;

  const elapsed = open ? Math.floor((Date.now() - new Date(open.clock_in).getTime()) / 1000) : 0;

  const act = async (fn, okMsg) => {
    setBusy(true);
    try {
      await fn();
      if (okMsg) toast.success(okMsg);
      if (onChange) await onChange();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Fehlgeschlagen');
    }
    setBusy(false);
  };

  return (
    <div className="mt-3 w-full max-w-[160px] mx-auto" data-testid="clock-in-widget">
      {open ? (
        <button onClick={() => act(api.clockOut, 'Ausgestempelt')} disabled={busy} data-testid="clock-out-btn"
          className="w-full flex items-center justify-center gap-2 rounded-sm border border-red-500/40 bg-red-500/10 text-red-300 hover:bg-red-500/20 transition-colors px-3 py-2 disabled:opacity-50">
          {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Square className="w-3.5 h-3.5" />}
          <span className="text-xs font-medium">Clock-out</span>
          <span className="text-[11px] font-mono text-red-200/90 tabular-nums" data-testid="clock-elapsed">{hhmmss(elapsed)}</span>
        </button>
      ) : (
        <button onClick={() => act(api.clockIn, 'Eingestempelt')} disabled={busy} data-testid="clock-in-btn"
          className="w-full flex items-center justify-center gap-2 rounded-sm border border-emerald-500/40 bg-emerald-500/10 text-emerald-300 hover:bg-emerald-500/20 transition-colors px-3 py-2 disabled:opacity-50">
          {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Play className="w-3.5 h-3.5" />}
          <span className="text-xs font-medium">Clock-in</span>
        </button>
      )}
    </div>
  );
}
